import { LEGACY_TRANSCRIBER_DISPLAY_NAMES, TRANSCRIBER_FEATURE_NAME } from './constants';
import logger from './logger';
/**
 * 是否为转写机器人显示名（含历史英文名与产品中文名）。
 *
 * @param {string|undefined} name - 参与者显示名.
 * @returns {boolean}
 */
export function isTranscriberDisplayName(name) {
    if (!name) {
        return false;
    }
    const trimmed = name.trim();
    if (LEGACY_TRANSCRIBER_DISPLAY_NAMES.has(trimmed)) {
        return true;
    }
    // 大小写兜底（部分部署 nick 可能被改写）
    const lower = trimmed.toLowerCase();
    return lower === 'transcriber' || lower === 'jigasi transcriber';
}
/**
 * 判断 lib-jitsi-meet 参与者是否应作为透明系统机器人（不进 UI）。
 * 官方路径靠 hiddenDomain；再按 feature / 显示名兜底。
 * 独立文件避免 conference ↔ participants 循环依赖导致过滤函数未初始化。
 *
 * @param {any} user - JitsiParticipant 或类参与者对象.
 * @returns {boolean}
 */
export function isTransparentSystemParticipant(user) {
    if (!user) {
        return false;
    }
    try {
        if (typeof user.isHidden === 'function' && user.isHidden()) {
            return true;
        }
        if (typeof user.hasFeature === 'function' && user.hasFeature(TRANSCRIBER_FEATURE_NAME)) {
            return true;
        }
        const displayName = typeof user.getDisplayName === 'function'
            ? user.getDisplayName()
            : user.name;
        if (isTranscriberDisplayName(displayName)) {
            return true;
        }
        // Jigasi 电话图标机器人且名为空时，仍可能是转写入会（nick 后到）
        if (user.isJigasi && !displayName) {
            return true;
        }
    }
    catch (e) {
        logger.warn('判断透明系统参与者失败', e);
    }
    return false;
}
